module.exports = __webpack_public_path__ + "media/images/app/testimonials/reviews/BNG1061-RD.Y-668e5414449158c72955a602c27fed61.webp";